<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/sendgoods/list'

export default {
  name: "sendgoods",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>